import { useState } from 'react';
import { useDeepCompareEffect } from 'react-use';

import { MedicalServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { Anchor, AnchorAlignment, Notification, NotificationType, StyledFlex } from '@dreryk/react-components';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';

import { isEmpty } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsPractitionerValue } from './GroupSessionsPractitionersField.types';

type GroupSessionsMedicalServiceNoificationProps = {
   selectedPractitioners: GroupSessionsPractitionerValue[];
   selectedMedicalService: MedicalServiceWithPractitionersSimple | null | undefined;
};

export const GroupSessionsMedicalServiceNoification = (
   props: GroupSessionsMedicalServiceNoificationProps
): JSX.Element | null => {
   const [practitionersNotAssignedToMedicalService, setPractitionersNotAssignedToMedicalService] = useState<
      GroupSessionsPractitionerValue[]
   >([]);

   useDeepCompareEffect(() => {
      if (isEmpty(props.selectedPractitioners) || isEmpty(props.selectedMedicalService)) {
         return setPractitionersNotAssignedToMedicalService([]);
      }

      const medicalServicePractitionersSet = new Set(
         props.selectedMedicalService.practitioners.map(({ practitioner }) => practitioner.id)
      );

      return setPractitionersNotAssignedToMedicalService(
         props.selectedPractitioners.filter(
            (practitioner) => !medicalServicePractitionersSet.has(practitioner.id.asNumber())
         )
      );
   }, [props.selectedMedicalService, props.selectedPractitioners]);

   if (isEmpty(practitionersNotAssignedToMedicalService)) {
      return null;
   }

   return (
      <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.END} testId={'serviceLocationWarning'}>
         <StyledFlex direction={'column'} gap={'4px'}>
            {practitionersNotAssignedToMedicalService.map((practitioner) => (
               <Notification
                  key={practitioner.id.asNumber()}
                  testId={'serviceLocationWarning'}
                  type={NotificationType.WARNING}
                  label={createInterpolatedTranslationKey(translationKeys.practitionerHasNoAssignedMedicalService, {
                     practitionerName: practitioner.displayName,
                  })}
               />
            ))}
         </StyledFlex>
      </Anchor>
   );
};
